import React, { useEffect } from 'react'
import NoResultsContainer from '../NoResults/NoResults'
import { useByStudent } from '../ByStudentContext/ByStudentContext'
import Loading from '../../../../../Loading/Loading'
import DetailedChart from '../../../../../commom/AnaCharts/DetailedChart'
import { useSelector } from 'react-redux'
import PartitionChart from './Test'

const CurriculumLevels = () => {
  const { studentSelected, curriculumId, onLoadCurriculumLevels, loading, dataChart } = useByStudent()
  const state = useSelector((state) => state?.filter?.learningMatrix || {})

  useEffect(() => {
    if (curriculumId && studentSelected) {
      onLoadCurriculumLevels(curriculumId, studentSelected, state.filter)
    }
  }, [curriculumId, studentSelected, state.filter])

  return (
    <div className='absolute inset-0'>
      {loading ? (
        <Loading />
      ) : dataChart?.data?.length > 0 ? (
        // <PartitionChart
        //   data={dataChart?.data?.[0] || {}}
        //   types={dataChart?.types || []}
        // />
        <DetailedChart
          chartID='detailed-chart-curriculum-levels'
          dataSet={{
            datasets: dataChart?.data || [],
            types: dataChart.types
          }}
        />
      ) : (
        <NoResultsContainer />
      )}
    </div>
  )
}

export default CurriculumLevels
